<template>
  <div>
    <v-row
      no-gutters
      >
      <v-menu
        ref="startMenuRef"
        v-model="startMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="start"
        transition="scale-transition"
        offset-y
        full-width
      >
        <template v-slot:activator="{ on }">
          <v-col
            cols=12
            md=3
            sm=6>
            <v-text-field
              v-model="start"
              label="開始時刻"
              prepend-icon="access_time"
              readonly
              v-on="on"
              v-validate="'required'"
              data-vv-name="start"
              data-vv-as="開始時刻"
              required
              :error-messages="errors.collect('start')"
            ></v-text-field>
          </v-col>
        </template>
        <v-time-picker
          v-if="startMenu"
          v-model="start"
          :allowed-minutes="allowedMinutes"
          full-width
          @click:minute="$refs.startMenuRef.save(start)"
        ></v-time-picker>
      </v-menu>
      <v-menu
        ref="endMenuRef"
        v-model="endMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="end"
        transition="scale-transition"
        offset-y
        full-width
      >
        <template v-slot:activator="{ on }">
          <v-col
            cols=12
            md=3
            sm=6>
            <v-text-field
              v-model="end"
              label="終了時刻"
              prepend-icon="access_time"
              readonly
              v-on="on"
              v-validate="'required'"
              data-vv-name="end"
              data-vv-as="終了時刻"
              required
              :error-messages="errors.collect('end')"
            ></v-text-field>
          </v-col>
        </template>
        <v-time-picker
          v-if="endMenu"
          v-model="end"
          :allowed-minutes="allowedMinutes"
          full-width
          @click:minute="$refs.endMenuRef.save(end)"
        ></v-time-picker>
      </v-menu>
    </v-row>
    <v-row
      no-gutters>
      <v-col
        md=6>
        <v-select
          v-model="wage"
          :items="wageRange"
          label="報酬（円）"
          v-validate="'required'"
          data-vv-name="wage"
          data-vv-as="報酬額"
          required
          :error-messages="errors.collect('wage')"
          >
        </v-select>
      </v-col>
    </v-row>
    <v-row
      no-gutters>
      <v-col>
        <v-textarea
        v-model="note"
        label="コメント"
        outlined></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: Object
  },
  data () {
    return {
      startMenu: null,
      endMenu: null
    }
  },
  methods: {
    allowedMinutes: m => m % 15 === 0,
    updateValue(diff) {
      this.$emit('input', { ...this.value, ...diff})
    }
  },
  computed: {
    wageRange: function () {
      var range = new Array()
      var i
      for (i = 0; i <= 200; i++) {
        range.push(i*100)
      }
      return range
    },
    schedule: {
      get () {
        return this.value.schedule
      },
      set (schedule) {
        this.updateValue({ schedule })
      }
    },
    day: function () {
      return this.schedule.day
    },
    start: {
      get () {
        return this.value.schedule.start
      },
      set (start) {
        this.schedule = {
          day: this.day,
          start: start,
          end: this.end
        }
      },
    },
    end: {
      get () {
        return this.value.schedule.end
      },
      set (end) {
        this.schedule = {
          day: this.day,
          start: this.start,
          end: end
        }
      }
    },
    wage: {
      get () {
        return this.value.wage
      },
      set (wage) {
        this.updateValue({ wage })
      }
    },
    note: {
      get () {
        return this.value.note
      },
      set (note) {
        this.updateValue({ note })
      }
    }
  }
}
</script>
